export const basicBtns = [
  {
    label: "编辑",
    value: "edit",
    icon:"basic-button_edit"
  },
  {
    label: "删除",
    value: "delete",
    icon: "basic-button_delete"
  },
  {
    label: "锁定",
    value: "lock",
    icon: "basic-button_lock"
  },
  {
    label: "解锁",
    value: "unlock",
    icon: "basic-button_unlock"
  },
  {
    label: "打印",
    value: "print",
    icon: "basic-button_print"
  },
  {
    label: "复制",
    value: "copy",
    icon: "basic-button_copy"
  },
  {
    label: "同步",
    value: "sync",
    icon: "basic-button_sync"
  },
  {
    label: "关联项目",
    value: "project",
    icon: "basic-button_project"
  }
]

export const controlRequiredAttrsMap = {
  ref:{
    common:{
      refSheetId:"关联表",
      oneFlag:"数量",
      fields:"显示字段"
    }
  },
  field: {
    common:{
      refCid:"关联表字段",
      field:"显示字段"
    }
  },
  gather:{
    common:{
      sourceCid:"关联表",
      gatherCid:"汇总字段",
      gatherType:"汇总类型"
    }
  },
  calc:{
    common:{
      calcType:"类型"
    },
    special:{
      NUM:{
        expression:"计算表达式"
      },
      DATE:{
        var1:"计算表达式",
        var2:"计算表达式",
        calcUnit:"计算单位",
        unit:"转换单位"
      },
      LOCATION:{
        var1:"计算表达式",
        var2:"计算表达式",
        calcUnit:"计算单位",
        unit:"转换单位"
      },
      OPTION:{
        expression:"关联选择",
        optionValueMap:"关联选择",
        optionDefaultValue:"默认赋值"
      }
    }

  },
  progress:{
    common:{
      step:"步长"
    }
  },
  code:{
    common:{
      targetCid:"字段",
      sign:"模板"
    }
  },
  money_cn:{
    common:{
      refCid:"关联金额"
    }
  },
  remark:{
    common:{
      hint:'内容'
    }
  },
  chart:{
    common:{
      dashboardId:"关联看板",
      chartId:"关联图表",
    }
  },
}

export const canCalcFieldTypes = ["number", "money", "field", "gather"]

export const allCanCalcFieldTypes = ["number", "money", "field", "gather","time","location"]

